import { SvgIcon, SvgIconProps } from "@material-ui/core";
import { Cooperation } from "../../gardener/gardener.model";

export interface LevelIconProps extends SvgIconProps {
    cooperationLevel: Cooperation["level"];
}

export const LevelIcon = (props: LevelIconProps) => {
    const { cooperationLevel, ...otherProps } = props;

    const fillColor = (() => {
        switch ( cooperationLevel ) {
            case "bronze": return "#CC6621";
            case "silver": return "#818181";
            case "gold": return "#FFB833";
            case "platin": return "#0076EB";
        }
    })();

    return (
        <SvgIcon {...otherProps}>
            <g clipPath="url(#clip0_4547_3943)">
                <path d="M12.5 4.5C9.19 4.5 6.5 7.19 6.5 10.5C6.5 13.81 9.19 16.5 12.5 16.5C15.81 16.5 18.5 13.81 18.5 10.5C18.5 7.19 15.81 4.5 12.5 4.5ZM14.81 14.19L12.5 12.43L10.18 14.19L11.06 11.34L8.75 9.5H11.59L12.5 6.69L13.41 9.5H16.25L13.93 11.34L14.81 14.19ZM12.5 19.5L8.5 20.52V17.42C9.68 18.1 11.04 18.5 12.5 18.5C13.96 18.5 15.32 18.1 16.5 17.42V20.52L12.5 19.5Z" fill="white" />
                <path d="M10.18 14.19L12.5 12.43L14.81 14.19L13.93 11.34L16.25 9.5H13.41L12.5 6.69L11.59 9.5H8.75L11.06 11.34L10.18 14.19ZM20.5 10.5C20.5 6.08 16.92 2.5 12.5 2.5C8.08 2.5 4.5 6.08 4.5 10.5C4.5 12.53 5.26 14.37 6.5 15.78V23.5L12.5 21.5L18.5 23.5V15.78C19.74 14.37 20.5 12.53 20.5 10.5ZM12.5 4.5C15.81 4.5 18.5 7.19 18.5 10.5C18.5 13.81 15.81 16.5 12.5 16.5C9.19 16.5 6.5 13.81 6.5 10.5C6.5 7.19 9.19 4.5 12.5 4.5ZM12.5 19.5L8.5 20.52V17.42C9.68 18.1 11.04 18.5 12.5 18.5C13.96 18.5 15.32 18.1 16.5 17.42V20.52L12.5 19.5Z" fill={fillColor} />
            </g>
            <defs>
                <clipPath id="clip0_4547_3943">
                    <rect width="24" height="24" fill="white" transform="translate(0.5 0.5)"/>
                </clipPath>
            </defs>

        </SvgIcon>
    );
};
